import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, debounceTime, map } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdateField, UpdateRelease } from '../action-creators';
import { UPDATE_FIELD } from '../actions';
import AppState from '../../state';
import { Release } from '@common/types/release/release';


export const autosaveEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, UpdateField<any>>(UPDATE_FIELD),
    filter((action) => !action.disableAutoSave),
    withLatestFrom(state$),
    filter(([_, state]) => !!(state.release.updateStatus === 'modified' && state.release.release?.id && !state.release.locked)),
    debounceTime(2000),
    map(([_, state]) => new UpdateRelease(state.release.release as Partial<Release>))
  );